import { Location } from '../types';

/** Build the full, root-to-child display path for a location. */
export const getLocationPath = (
  location: Location,
  locations: Location[],
): string => {
  const path = [location.name];
  const visited: Record<string, boolean> = { [location.id]: true };
  let parentId = location.parent_location_id;

  while (parentId && !visited[parentId]) {
    const parent = locations.find((candidate) => candidate.id === parentId);
    if (!parent) break;
    path.unshift(parent.name);
    visited[parent.id] = true;
    parentId = parent.parent_location_id;
  }
  return path.join(' → ');
};

/** Sort locations by their full hierarchy path for predictable selects. */
export const sortLocationsByPath = (locations: Location[]): Location[] =>
  [...locations].sort((left, right) =>
    getLocationPath(left, locations).localeCompare(getLocationPath(right, locations)),
  );
